import { useEffect, useState } from 'react';

import { useGetMyTeachingStructureItemsQuery } from '@school_ify/schoolify-repository/src/teacher/types';
import { useGetMySubjectsQuery } from '@school_ify/schoolify-repository/src/student/types';

import { useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';

import PrintSubjects from './components/Subjects/PrintSubjects';

const StudyIndex = () => {
  const user = useAppSelector(getUser);

  const [subjectsList, setSubjectsList] = useState([]);
  const {
    data: teacherSubjects,
    loading: teacherSubjectsLoading,
    refetch: teacherSubjectsRefetch,
  } = useGetMyTeachingStructureItemsQuery();

  const {
    data: studentSubjects,
    loading: studentsSubjectLoading,
    refetch: studentSubjectsRefetch,
  } = useGetMySubjectsQuery();

  useEffect(() => {
    if (user.role === 'teacher') {
      teacherSubjectsRefetch({
        _eq: user.id,
      }).then();
    }

    if (user.role === 'student') {
      studentSubjectsRefetch({
        _eq: user.id, // value for '_eq'
      }).then();
    }
  }, []);

  useEffect(() => {
    if (!studentsSubjectLoading && studentSubjects) {
      setSubjectsList(studentSubjects.teaching_structure_students);
    }
  }, [studentsSubjectLoading]);

  useEffect(() => {
    if (!teacherSubjectsLoading && teacherSubjects) {
      setSubjectsList(teacherSubjects.teacher_subject);
    }
  }, [teacherSubjectsLoading]);

  return (
    <div>
      <div className="mt-4 mb-4 ml-3 mr-3">
        <PrintSubjects subjects={subjectsList} />
      </div>
    </div>
  );
};

export default StudyIndex;
